import React, { Component } from "react";
import HeaderNav from "./common/HeaderNav";
import "./styles/Number.css";
import { Link } from "react-router-dom";
// import SideFilterBar from "./common/SideFilterBar";
// search field
import TextField from "@mui/material/TextField";
// search button
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import ReplayIcon from "@mui/icons-material/Replay";
import MenuIcon from "@mui/icons-material/Menu";
import Footer from "./Footer";
import { Button } from "@mui/material";
import apiCall from "../utils/apiCall";
import NumberBox from "./common/NumberBox";
import styledComponents from "./styles/styledComponents";
import Model from "./common/Model";
import { connect } from "react-redux";
import { cartInfo } from "./common/redux/actions";
import GlobalAdvancedSearchBar from "./common/GlobalAdvancedSearchBar";
// import { ThemeProvider } from 'styled-components';
import { createTheme, ThemeProvider } from "@mui/material/styles";
import queryString from "query-string";

const theme = createTheme({
  palette: {
    secondary: {
      main: "#000040",
    },
  },
});

// import Box from '@mui/material/Box';
// import Modal from '@mui/material/Modal';

let mountLimit = 1;
let retryLimit = 1;
const {
  IconWhiteHover,
  Form,
  ButtonWrapper,
  ButtonSecondary,
  ButtonSuccess,
  Title,
  SubHeading,
} = styledComponents;

class OfferZone extends Component {
  state = {
    numbers: [],
    numbersCategory: [],
    filterData: { categoryId: [] },
    sumTotalSerchText: "",
    totalNumbersSize: 0,
    totalCategorySize: 0,
    getNumbersLimit: 20,
    loadMoreNumbersLimit: 20,
    getCategoryLimit: 20,
    loadMoreCategoryLimit: 20,
    searchObject: {},
    infoNumber: {},
    currentWidth: 0,
    openMobileFilter: false,
    infoModelOpen: false,
    isInitialSearchDone: false,
    setShowIframe: false,
  };

  async componentDidMount() {
    // Only handle initial mount logic here
    window.scrollTo(0, 0);
    document.title =
      "Exclusive VIP Mobile Numbers for Sale in India | Fancy & Premium Numbers";
    document
      .querySelector("meta[name='description']")
      .setAttribute(
        "content",
        "Explore a wide collection of VIP mobile numbers at VIP Number Studio. Find premium, fancy, and unique numbers at the best prices. Buy your perfect number now!"
      );

    await this.getCategory();

    // Check for category parameter in URL and apply filter
    const urlParams = new URLSearchParams(window.location.search);
    const categoryId = urlParams.get("categoryId");

    if (categoryId) {
      // Set the filter state first, then load data
      const filterData = {
        ...this.state.filterData,
        categoryId: [parseInt(categoryId)],
        status: [2],
      };

      this.setState({ filterData }, () => {
        // Load data with the filter applied
        this.loadNumbers(filterData);
      });
    } else {
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.toString()) {
        this.loadNumbersFromURL();
      } else {
        this.loadNumbers();
      }
    }
  }

  loadNumbersFromURL = async () => {
    const urlParams = new URLSearchParams(window.location.search);
    const filterData = {
      status: [2], // Ensure status is always set
      limit: this.state.getNumbersLimit || 20,
      skip: 0,
    };

    // Parse URL parameters into filter data
    for (let [key, value] of urlParams.entries()) {
      if (key === "searchBarText" && value !== "true") {
        filterData.textToSearch = value;
      } else if (key === "status") {
        filterData.status = value
          .split(",")
          .map((s) => parseInt(s))
          .filter((s) => !isNaN(s));
      } else if (key === "categoryId") {
        filterData.categoryId = value
          .split(",")
          .map((v) => parseInt(v.trim()))
          .filter((v) => !isNaN(v));
      } else if (key === "categoryName") {
        filterData.categoryName = value
          .split(",")
          .map((v) => v.trim())
          .filter((v) => v);
      } else if (key === "sumOne") {
        filterData.sumOne = value
          .split(",")
          .map((v) => v.trim())
          .filter((v) => v);
      } else if (key === "sumTwo") {
        filterData.sumTwo = value
          .split(",")
          .map((v) => v.trim())
          .filter((v) => v);
      } else if (key === "numberExact") {
        // Backend now supports numberExact directly
        filterData.numberExact = value
          .split(",")
          .map((v) => v.trim())
          .filter((v) => v);
      } else if (key === "numberStartsWith") {
        // Backend now supports numberStartsWith directly
        filterData.numberStartsWith = value
          .split(",")
          .map((v) => v.trim())
          .filter((v) => v);
      } else if (key === "numberEndsWith") {
        // Backend now supports numberEndsWith directly
        filterData.numberEndsWith = value
          .split(",")
          .map((v) => v.trim())
          .filter((v) => v);
      } else if (key === "numberContains") {
        // Backend now supports numberContains directly
        filterData.numberContains = value
          .split(",")
          .map((v) => v.trim())
          .filter((v) => v);
      } else if (key === "priceExact") {
        // Backend now supports priceExact directly
        filterData.priceExact = value
          .split(",")
          .map((v) => v.trim())
          .filter((v) => v);
      } else if (key === "priceMin") {
        // Backend now supports priceMin directly
        filterData.priceMin = value;
      } else if (key === "priceMax") {
        // Backend now supports priceMax directly
        filterData.priceMax = value;
      } else if (
        [
          "sumTotal",
          "startDate",
          "endDate",
          "sortByPrice",
          "sortBySeries",
          "limit",
        ].includes(key)
      ) {
        filterData[key] = value;
      }
    }

    // Debug logging
    console.log("URL Params:", Object.fromEntries(urlParams.entries()));
    console.log("Constructed Filter Data:", filterData);

    // Call loadNumbers with the constructed filter data
    this.loadNumbers(filterData);
  };

  loadNumbers = async (filterData = null) => {
    if (mountLimit == 1 || retryLimit == 2) {
      mountLimit++;
      try {
        console.log("URL Search:", window.location.search);
        console.log("Filter Data Received:", filterData);
        console.log("Initial Search Done:", this.state.isInitialSearchDone);

        let getNumbers = {};

        if (filterData) {
          // Use the filterData directly since backend now supports all parameters
          const apiFilterData = {
            ...filterData,
            status: filterData.status || [2], // Ensure status is set
          };

          console.log("API Filter Data:", apiFilterData);

          const { result } = await apiCall(
            "REACT_APP_GET_NUMBERS",
            "POST",
            apiFilterData,
            false
          );
          getNumbers = result;
        } else if (
          queryString.parse(window.location.search).searchBarText &&
          !this.state.isInitialSearchDone
        ) {
          let queryParams = queryString.parse(window.location.search);
          console.log("queryParams", queryParams);
          console.log("queryParams.searchBarText", queryParams.searchBarText);

          if (queryParams.searchBarText) {
            const { result } = await apiCall("REACT_APP_GET_NUMBERS", "POST", {
              textToSearch: queryParams.searchBarText,
              limit: this.state.getNumbersLimit,
              status: [2],
            });
            getNumbers = result;
          }

          // GET CATEGORY
          await this.getCategory();
          window.history.pushState("", "", "/numbers");
          this.setState({ isInitialSearchDone: true });
        } else {
          // Default case - load all numbers
          const { result } = await apiCall("REACT_APP_GET_NUMBERS", "POST", {
            limit: this.state.getNumbersLimit || 20,
            skip: 0,
            status: [2],
          });
          getNumbers = result;

          // GET CATEGORY
          await this.getCategory();
        }

        console.log("API Response:", getNumbers);
        console.log("retryLimit", retryLimit);
        console.log("mountLimit", mountLimit);

        if (getNumbers && getNumbers["success"] && getNumbers["status"]) {
          let modifyData = await this.modifyApiData(getNumbers.status);
          this.setState({
            numbers: modifyData,
            totalNumbersSize: getNumbers.totalSize,
            loadMoreNumbersLimit: this.state.getNumbersLimit,
          });
          retryLimit = 1;
        } else if (retryLimit == 1) {
          console.log("Retrying API call");
          retryLimit++;
          this.loadNumbers(filterData); // Pass the same filterData for retry
        }

        this.setState({
          currentWidth: window.innerWidth,
          openMobileFilter: false,
        });
      } catch (error) {
        console.log("loadNumbers Error:", error);
      }

      setTimeout(() => {
        mountLimit = 1;
      }, 500);
    }
  };

  async getCategory() {
    try {
      const { result } = await apiCall("REACT_APP_GET_CATEGORY", "POST", {
        limit: this.state.getCategoryLimit || 20,
        skip: 0,
      });

      if (result && result["success"] && result["status"]) {
        let modifyData = await this.modifyApiData(result.status);
        this.setState({
          numbersCategory: modifyData,
          totalCategorySize: result.totalSize,
        });
      }

      return;
    } catch (error) {
      console.log("getCategory Error::", error);
      return;
    }
  }

  async modifyApiData(rawDataArray) {
    return await rawDataArray.map((data) => {
      data.createdAt = new Date(data.createdAt).toLocaleString();
      data.updatedAt = new Date(data.updatedAt).toLocaleString();

      return data;
    });
  }

  handleChange = async (event, state) => {
    let filterData = this.state.filterData;
    filterData[state] = event.target.value;
    this.setState({ filterData });
  };

  handleKeyPress = async (event) => {
    console.log("eventbefore", event);
    if (event.key == "Enter") {
      console.log("event", event);
    }
  };

  submitMainSearch = async (event) => {
    console.log("submitMainSearch");

    try {
      let filterData = this.state.filterData;

      if (!filterData) {
        return;
      }
      filterData["limit"] = this.state.getNumbersLimit;
      this.loadNumbers(filterData); // FIX: call loadNumbers instead of componentDidMount
    } catch (error) {
      console.log("submitMainSearch :: Error ::", error);
    }
  };

  sortButtonClick = async (event, th) => {
    try {
      let button = event.target.title;
      let filterData = {};

      // Reset previous active button styles
      document.querySelectorAll(".sort-button").forEach((btn) => {
        btn.style.backgroundColor = "#000040"; // Default color
      });

      // Set active button style
      event.target.style.backgroundColor = "red";

      if (button == "pLH") {
        filterData["sortByPrice"] = "ASC";
      } else if (button == "pHL") {
        filterData["sortByPrice"] = "DESC";
      } else if (button == "sLH") {
        filterData["sortBySeries"] = "ASC";
      } else if (button == "sHL") {
        filterData["sortBySeries"] = "DESC";
      }else if (button == "prebook") {
        filterData["isAvailableForPrebooking"] = 1;
      } else {
        filterData = null;
      }

      if (!filterData) {
        return;
      }

      filterData["limit"] = this.state.getNumbersLimit;
      this.setState({ filterData });
      this.loadNumbers(filterData); // FIX: call loadNumbers instead of componentDidMount
    } catch (error) {
      console.log("submitMainSearch :: Error ::", error);
    }
  };

  categoryButtonClick = (event, categoryData) => {
    console.log("categoryButtonClick");

    try {
      if (!categoryData) return;

      let selectedCategories = [...this.state.filterData.categoryId] || [];

      if (event.target.checked) {
        selectedCategories.push(categoryData.id);
      } else {
        selectedCategories = selectedCategories.filter(
          (id) => id !== categoryData.id
        );
      }

      let filterData = {
        ...this.state.filterData,
        categoryId: selectedCategories,
      };

      this.setState({ filterData }, () => {
        window.scrollTo({ top: 250, behavior: "smooth" });
        this.loadNumbers(filterData); // Use loadNumbers instead of componentDidMount
      });
    } catch (error) {
      console.log("submitMainSearch :: Error ::", error);
    }
  };

  loadMoreNumbers = async (event) => {
    try {
      let filterData = {};

      filterData["limit"] =
        parseInt(this.state.getNumbersLimit) +
        parseInt(this.state.loadMoreNumbersLimit);
      filterData["status"] = [2];

      const { result } = await apiCall(
        "REACT_APP_GET_NUMBERS",
        "POST",
        filterData
      );

      if (result && result["success"] && result["status"]) {
        let modifyData = await this.modifyApiData(result.status);
        this.setState({
          numbers: modifyData,
          totalNumbersSize: result.totalSize,
          loadMoreNumbersLimit: filterData["limit"],
        });
      }

      return;
    } catch (error) {
      console.log("getCategory Error::", error);
      return;
    }
  };

  loadMoreCategory = async (event) => {
    try {
      let filterData = {};

      filterData["limit"] =
        parseInt(this.state.getCategoryLimit) +
        parseInt(this.state.loadMoreCategoryLimit);

      const { result } = await apiCall(
        "REACT_APP_GET_CATEGORY",
        "POST",
        filterData
      );

      if (result && result["success"] && result["status"]) {
        let modifyData = await this.modifyApiData(result.status);
        this.setState({
          numbersCategory: modifyData,
          totalCategorySize: result.totalSize,
          loadMoreCategoryLimit: filterData["limit"],
        });
      }

      return;
    } catch (error) {
      console.log("getCategory Error::", error);
      return;
    }
  };

  showMobileFilter = (e) => {
    if (this.state.openMobileFilter == false) {
      this.setState({ openMobileFilter: true });
    } else {
      this.setState({ openMobileFilter: false });
    }
  };

  renderSearchBar = () => {
    return <GlobalAdvancedSearchBar history={this.props.history} />;
  };

  renderNumbersWithBox = () => {
    const discountedNumbers = this.state.numbers.filter(
      (eachNumberData) => eachNumberData.discount && eachNumberData.discount > 0
    );

    return (
      <React.Fragment>
        {discountedNumbers.map((eachNumberData) => (
          <NumberBox
            key={eachNumberData.number}
            numberData={eachNumberData}
            setCurrentNumber={(data) => {
              this.setState({ infoNumber: data, infoModelOpen: true });
            }}
          />
        ))}
        <div
          style={{
            display:
              discountedNumbers.length === this.state.totalNumbersSize
                ? "none"
                : "flex",
          }}
          id="loadMoreButtonContainer"
        >
          <Button
            class="btn-loadmore"
            onClick={(e) => {
              this.loadMoreNumbers(e);
            }}
          >
            Load More
          </Button>
        </div>
      </React.Fragment>
    );
  };

  handleInfoBtnAddToCartClick = (e, data) => {
    if (!data) {
      return;
    }

    this.props.cartInfo({ cartDetails: data });
    this.setState({ infoModelOpen: false });
  };

  closeModel = (closeModelKey) => {
    console.log("closeModelKey", closeModelKey);
    if (closeModelKey) {
      let updateState = {};
      updateState[closeModelKey] = false;
      this.setState(updateState);
    }
  };
  toggleIframe = () => {
    this.setState((prevState) => ({ setShowIframe: !prevState.setShowIframe }));
  };

  render() {
    console.log("this.state ===============>", this.state);
    console.log("this.props ===============>", this.props);
    return (
      <React.Fragment>
        <div id="mainNumbersContainer">
          {/* Render Header Nav Bar */}
          <HeaderNav activeTabName="offerzone" />
          <div
            style={{
              position: "relative",
              width: "100%",
              height: "300px",
              overflow: "hidden",
              marginTop: "65px",
            }}
          >
            {/* Background Image */}
            <div
              style={{
                position: "absolute",
                width: "100%",
                height: "100%",
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            ></div>

            {/* Gradient Overlay */}
            <div
              style={{
                position: "absolute",
                width: "100%",
                height: "100%",
                background: "#000040",
              }}
            ></div>
            {/* Red circular accent */}
            <div
              style={{
                position: "absolute",
                width: "300px",
                height: "300px",
                backgroundColor: "rgba(255, 0, 0, 0.8)",
                borderRadius: "50%",
                top: "-150px",
                right: "-100px",
                zIndex: 1,
              }}
            ></div>

            {/* Second red circular accent */}
            <div
              style={{
                position: "absolute",
                width: "150px",
                height: "150px",
                backgroundColor: "rgba(255, 0, 0, 0.8)",
                borderRadius: "50%",
                bottom: "-70px",
                left: "50px",
                zIndex: 1,
              }}
            ></div>

            {/* Decorative dots */}
            <div
              style={{
                position: "absolute",
                top: "20px",
                left: "20px",
                display: "flex",
                gap: "5px",
              }}
            >
              <div
                style={{
                  width: "8px",
                  height: "8px",
                  borderRadius: "50%",
                  backgroundColor: "rgba(255, 255, 255, 0.7)",
                }}
              ></div>
              <div
                style={{
                  width: "8px",
                  height: "8px",
                  borderRadius: "50%",
                  backgroundColor: "rgba(255, 255, 255, 0.7)",
                }}
              ></div>
              <div
                style={{
                  width: "8px",
                  height: "8px",
                  borderRadius: "50%",
                  backgroundColor: "rgba(255, 255, 255, 0.7)",
                }}
              ></div>
            </div>

            {/* Decorative triangle */}
            <div
              style={{
                position: "absolute",
                bottom: "15px",
                right: "60px",
                width: 0,
                height: 0,
                borderLeft: "15px solid transparent",
                borderRight: "15px solid transparent",
                borderBottom: "26px solid rgba(255, 255, 255, 0.15)",
                transform: "rotate(45deg)",
              }}
            ></div>

            {/* Content Container */}
            <div
              style={{
                position: "relative",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                padding: "0 20px",
                zIndex: "2",
              }}
            >
              <h1
                style={{
                  color: "white",
                  fontSize: "42px",
                  fontWeight: "800",
                  marginBottom: "16px",
                  textAlign: "center",
                  textShadow: "2px 2px 8px rgba(0, 0, 0, 0.6)",
                }}
              >
                Offer Zone
              </h1>

              <p
                style={{
                  color: "white",
                  fontSize: "18px",
                  fontWeight: "400",
                  maxWidth: "700px",
                  textAlign: "center",
                  textShadow: "1px 1px 4px rgba(0, 0, 0, 0.8)",
                }}
              >
                Buy premium & fancy VIP mobile numbers in India
              </p>

              {/* Decorative Line */}
              <div
                style={{
                  width: "80px",
                  height: "4px",
                  background:
                    "linear-gradient(90deg,rgba(255, 255, 255, 0.74), rgb(233, 2, 2))",
                  marginTop: "20px",
                  borderRadius: "2px",
                }}
              ></div>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <h1
              className="heading"
              style={{
                marginBottom: "28px",
                fontWeight: "bolder",
                marginTop: "28px",
              }}
            >
              Offer Zone for <span className="c-red">VIP</span> Mobile Numbers
              in India
            </h1>
          </div>
          <div id="subMainContainer">
            {/* Render side bar conditionally */}
            <div
              className={this.state.openMobileFilter ? "open" : ""}
              id="sideFilterBar"
            >
              { /* SideFilterBar temporarily disabled */ }
            </div>

            {/* Render numbers container with conditions */}
            <div
              style={{
                width: this.state.openMobileFilter ? "20%" : "100%",
              }}
              id="subContainer"
            >
              {this.renderSearchBar()}
              <div
                style={{
                  display: this.state.openMobileFilter ? "none" : "grid",
                }}
                id="subItemsContainer"
              >
                {window.location.search &&
                queryString.parse(window.location.search).number
                  ? this.renderNumberInfo(window.location.search)
                  : this.renderNumbersWithBox()}
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return { state };
};

export default connect(mapStateToProps, { cartInfo })(OfferZone);
